import React, { useEffect, useState } from "react";
import { TouchApp, RadioButtonUnchecked } from "@mui/icons-material";

const ButtonPressDetail1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "idle" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "idle";
    return value;
  };

  const isPressed = () => {
    return value && value !== "idle";
  };

  const getPressIcon = () => {
    return isPressed() ? (
      <TouchApp style={{ fontSize: "1.5rem", color: "white" }} />
    ) : (
      <RadioButtonUnchecked style={{ fontSize: "1.5rem", color: "white" }} />
    );
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Button Press Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "40px",
          backgroundColor: "hsl(var(--primary))",
          opacity: isPressed() ? 1 : 0.2,
        }}
      >
        <span className="text-white font-bold capitalize">
          {getStatusText()}
        </span>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          {getPressIcon()}
        </div>
      </div>
    </div>
  );
};

export default ButtonPressDetail1Widget;
